import { render, staticRenderFns } from "./HostServices.vue?vue&type=template&id=2649deba&"
import script from "./HostServices.vue?vue&type=script&lang=js&"
export * from "./HostServices.vue?vue&type=script&lang=js&"
import style0 from "./HostServices.vue?vue&type=style&index=0&id=2649deba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports